import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';
import { TESTING_CENTER } from 'src/app/dummy/tab';

@Component({
  selector: 'app-math-placement',
  templateUrl: './math-placement.component.html',
  styleUrls: ['./math-placement.component.scss']
})
export class MathPlacementComponent implements OnInit {
  tabs = TESTING_CENTER.GENERAL_TESTING_SKILL;
  error: any = null;
  TITLE = "General Placement Test"
  ITEM: any;
  SKILL_KEY: any = '';
  CLASS_KEY: any = '';

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private dialog: MatDialog
    , public store: PlacementTest
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
  ) { }

  goBack() {
    this.router.navigate([`/testing-center/general-placement-test/classes`])
  }

  ngOnInit() {
    this.route.params.subscribe(async params => {
      const { id, skillKey } = params
      this.CLASS_KEY = id;
      this.tabs = TESTING_CENTER.GENERAL_TESTING_SKILL.map(m => ({ path: `${m.path}/${id}`, label: m.label }))
      this.ITEM = await this.store.fetchClassTesting(id);
      this.SKILL_KEY = skillKey;
      if (!this.ITEM) {
        this.router.navigate([`/404`]);
      }
      this.store.fetchExercise(this.SKILL_KEY, this.CLASS_KEY)
    })
  }

  create(item: any) {
    this.router.navigate([`//testing-center/general-placement-test/${this.SKILL_KEY}/${this.ITEM.key}/${item ? item.key : 'draft'}`])
  }

}
